/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const YOURCONNECTIONREQUESTS= createAsyncThunk(
  "yourConnectionRequests/yourConnectionRequests",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const yourConnectionRequestsSlice = createSlice({
  name: "yourConnectionRequestsSlice",
  initialState: {
    yourConnectionRequests: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfyourConnectionRequests: (state) => {
        state.yourConnectionRequests.loading = false
        state.yourConnectionRequests.error = false
        state.yourConnectionRequests.data = []
        state.yourConnectionRequests.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(YOURCONNECTIONREQUESTS.fulfilled, (state, action) => {
      state.yourConnectionRequests = {
        ...state.yourConnectionRequests,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(YOURCONNECTIONREQUESTS.pending, (state, action) => {
      state.yourConnectionRequests = {
        ...state.yourConnectionRequests,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(YOURCONNECTIONREQUESTS.rejected, (state, action) => {
      state.yourConnectionRequests = {
        ...state.yourConnectionRequests,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const yourConnectionRequestsAction = {
    YOURCONNECTIONREQUESTS,
};

export { yourConnectionRequestsAction };
export default yourConnectionRequestsSlice.reducer;
export const {setInitialStateOfyourConnectionRequests} = yourConnectionRequestsSlice.actions